import { render } from "./IconPublish.vue?vue&type=template&id=66115387"
import script from "./IconPublish.vue?vue&type=script&lang=js"
export * from "./IconPublish.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__